import React, { useContext } from "react";
import styles from "./ViewARButton.module.scss";
import { LanguageContext } from "../../contexts/LanguageContext.jsx";

const ViewARButton = ({ onClick }) => {
  const { interfaceText } = useContext(LanguageContext);

  return (
    <button className={styles.viewARButton} onClick={onClick}>
      <span className={styles.text}>{interfaceText.viewInAR}</span>
      <span className={styles.arrow}>&nbsp;&nbsp;&gt;</span>
    </button>
  );
};

export default ViewARButton;
